//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getCombinationList as _getCombinationList } from "@api/activity";
import Loading from "@components/Loading";
export default {
  name: "GoodsGroup",
  components: {
    Loading: Loading
  },
  props: {},
  data: function data() {
    return {
      combinationList: [],
      status: false,
      //砍价列表是否获取完成 false 未完成 true 完成
      loading: false,
      //当前接口是否请求完成 false 完成 true 未完成
      page: 1,
      //页码
      limit: 10,
      //数量
      loadingList: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getCombinationList();
    this.$scroll(this.$refs.container, function () {
      !_this.loading && _this.getCombinationList();
    });
  },
  methods: {
    getCombinationList: function getCombinationList() {
      var that = this;
      if (that.loading) return;
      if (that.status) return;
      that.loading = true;

      _getCombinationList({
        page: that.page,
        limit: that.limit
      }).then(function (res) {
        that.status = res.data.length < that.limit;
        that.combinationList.push.apply(that.combinationList, res.data);
        that.page++;
        that.loading = false;
      }).catch(function () {
        that.loading = false;
      });
    },
    link: function link(id) {
      this.$router.push({
        path: "/activity/group_detail/" + id
      });
    }
  }
};